import { Material } from '@core/model/Material.model';
import { ProdWarning } from './prodWarning.model';

interface AccList {
    ItemId: string,
    ItemName: string,
    Type: number
 }

 interface ProcessList {
    Process: string,
    UrlImage: string,
    OnlyQuotProcess: boolean;
 }

export class ModelInfo {
    vModelo: string;
    vCodArticulo: string;
    vAncho1: number;
    vAlto1: number;
    vCantidad: number;
    vMoneda: string;
    vPrecio: number;
    vDescuento: number;
    vPorcDesc: number;
    vPorcDescCupons: number;
    vUnidad: string;
    shoppingCartItemId: number;
    vImagen: string;
    vTipoProduccion: number;
    vEspMinCapa: number;
    vEspMaxCapa: number;
    vEspMin: number;
    vEspMax: number;
    vSitio: string;
    vCliente: string;
    vProyecto: string;
    vModeloPadre: string;
    vRouteModel: string;
    vDetalleLinea: string;
    vReferencia: string;
    vMatStep: number;
    vReabastecimiento: number;
    vTiempoEntrega: number;
    vTiempoProd: number;
    vMsjError: string;
    vSoloCotiza: boolean;
    vTieneReglas: boolean;

    vListaMateriales: Material[];
    vListaRestricciones: ProdWarning[];
    vListaAccesorios: AccList[];
    vListaProcesos: ProcessList[];

    constructor() {
        this.vModelo = '';
        this.vCodArticulo = '';
        this.vAncho1 = 0;
        this.vAlto1 = 0;
        this.vCantidad = 1;
        this.vMoneda = '';
        this.vPrecio = 0;
        this.vDescuento = 0;
        this.vPorcDesc = 0;
        this.vPorcDescCupons = 0;
        this.vUnidad = 'un';
        this.shoppingCartItemId = 0;
        this.vImagen = '';
        this.vTipoProduccion = 0;
        this.vEspMinCapa = 0;
        this.vEspMaxCapa = 0;
        this.vEspMin = 0;
        this.vEspMax = 0;
        this.vSitio = '';
        this.vCliente = '';
        this.vProyecto = '';
        this.vModeloPadre = '';
        this.vRouteModel = '';
        this.vDetalleLinea = '';
        this.vReferencia = '';
        this.vMatStep = 0;
        this.vReabastecimiento = 0;
        this.vTiempoEntrega = 0;
        this.vTiempoProd = 0;
        this.vMsjError = '';
        this.vSoloCotiza = false;
        this.vListaMateriales = [];
        this.vListaRestricciones = [];
        this.vListaAccesorios = [];
        this.vListaProcesos = [];
    }

    redimensionarModelo() {
    }

    duplicarModelo() {
    }
}
